export enum TagCode {
	NewSubFileType = 254,
	SubFileType = 255,
	ImageWidth = 256,
	ImageLength = 257,
	BitsPerSample = 258,
	Compression = 259,
	PhotometricInterpretation = 262,
	Thresholding = 263,
	CellWidth = 264,
	CellLength = 265,
	FillOrder = 266,
	ImageDescription = 270,
	Make = 271,
	Model = 272,
	StripOffsets = 273,
	Orientation = 274,
	SamplesPerPixel = 277,
	RowsPerStrip = 278,
	StripByteCounts = 279,
	MinSampleValue = 280,
	MaxSampleValue = 281,
	XResolution = 282,
	YResolution = 283,
	PlanarConfiguration = 284,
	FreeOffsets = 285,
	FreeByteCounts = 286,
	GrayResponseUnit = 290,
	GrayResponseCurve = 291,
	ResolutionUnit = 296,
	TransferFunction = 301,
	Software = 305,
	DateTime = 306,
	Artist = 315,
	HostComputer = 316,
	Predictor = 317,
	WhitePoint = 318,
	PrimaryChromaticities = 319,
	ColorMap = 320,
	TileWidth = 322,
	TileLength = 323,
	TileOffsets = 324,
	TileByteCounts = 325,
	SubIFDs = 330,
	ExtraSamples = 338,
	SampleFormat = 339,
	JPEGTables = 347,
	JPEGProc = 512,
	JPEGInterchangeFormat = 513,
	JPEGInterchangeFormatLength = 514,
	YCbCrCoefficients = 529,
	YCbCrSubSampling = 530,
	YCbCrPositioning = 531,
	ReferenceBlackWhite = 532,
	XMP = 700,
	KodakCameraSerialNumber = 33405,
	CFARepeatPatternDim = 33421,
	CFAPattern = 33422,
	BatteryLevel = 33423,
	KodakDCRPrivateIFD = 33424,
	Copyright = 33432,
	ExposureTime = 33434,
	FNumber = 33437,
	IPTC_NAA = 33723,
	LeafPKTS = 34310,
	AdobeData = 34377,
	ExifIFD = 34665,
	ICCProfile = 34675,
	ExposureProgram = 34850,
	SpectralSensitivity = 34852,
	GPSInfo = 34853,
	ISOSpeedRatings = 34855, // EXIF 2.3: PhotographicSensitivity.
	OECF = 34856,
	Interlace = 34857,
	TimeZoneOffset = 34858,
	SelfTimerMode = 34859,
	SensitivityType = 34864,
	StandardOutputSensitivity = 34865,
	RecommendedExposureIndex = 34866,
	ISOSpeed = 34867,
	ISOSpeedLatitudeyyy = 34868,
	ISOSpeedLatitudezzz = 34869,
	ExifVersion = 36864,
	DateTimeOriginal = 36867,
	DateTimeDigitized = 36868,
	OffsetTime = 36880,
	OffsetTimeOriginal = 36881,
	OffsetTimeDigitized = 36882,
	ComponentsConfiguration = 37121,
	CompressedBitsPerPixel = 37122,
	ShutterSpeedValue = 37377,
	ApertureValue = 37378,
	BrightnessValue = 37379,
	ExposureBiasValue = 37380,
	MaxApertureValue = 37381,
	SubjectDistance = 37382,
	MeteringMode = 37383,
	LightSource = 37384,
	Flash = 37385,
	FocalLength = 37386,
	FlashEnergy = 37387,
	SpatialFrequencyResponse = 37388,
	Noise = 37389,
	FocalPlaneXResolution = 37390,
	FocalPlaneYResolution = 37391,
	FocalPlaneResolutionUnit = 37392,
	ImageNumber = 37393,
	SecurityClassification = 37394,
	ImageHistory = 37395,
	SubjectArea = 37396,
	ExposureIndex = 37397,
	TIFF_EP_StandardID = 37398,
	SensingMethod = 37399,
	MakerNote = 37500,
	UserComment = 37510,
	SubsecTime = 37520,
	SubsecTimeOriginal = 37521,
	SubsecTimeDigitized = 37522,
	AdobeLayerData = 37724,
	Temperature = 37888,
	Humidity = 37889,
	Pressure = 37890,
	WaterDepth = 37891,
	Acceleration = 37892,
	CameraElevationAngle = 37893,
	FlashPixVersion = 40960,
	ColorSpace = 40961,
	PixelXDimension = 40962,
	PixelYDimension = 40963,
	RelatedSoundFile = 40964,
	InteroperabilityIFD = 40965,
	FlashEnergyExif = 41483,
	SpatialFrequencyResponseExif = 41484,
	FocalPlaneXResolutionExif = 41486,
	FocalPlaneYResolutionExif = 41487,
	FocalPlaneResolutionUnitExif = 41488,
	SubjectLocation = 41492,
	ExposureIndexExif = 41493,
	SensingMethodExif = 41495,
	FileSource = 41728,
	SceneType = 41729,
	CFAPatternExif = 41730,
	CustomRendered = 41985,
	ExposureMode = 41986,
	WhiteBalance = 41987,
	DigitalZoomRatio = 41988,
	FocalLengthIn35mmFilm = 41989,
	SceneCaptureType = 41990,
	GainControl = 41991,
	Contrast = 41992,
	Saturation = 41993,
	Sharpness = 41994,
	DeviceSettingDescription = 41995,
	SubjectDistanceRange = 41996,
	ImageUniqueID = 42016,
	CameraOwnerNameExif = 42032,
	CameraSerialNumberExif = 42033,
	LensSpecificationExif = 42034,
	LensMakeExif = 42035,
	LensModelExif = 42036,
	LensSerialNumberExif = 42037,
	Gamma = 42240,
	PrintImageMatchingInfo = 50341,
	DNGVersion = 50706,
	DNGBackwardVersion = 50707,
	UniqueCameraModel = 50708,
	LocalizedCameraModel = 50709,
	CFAPlaneColor = 50710,
	CFALayout = 50711,
	LinearizationTable = 50712,
	BlackLevelRepeatDim = 50713,
	BlackLevel = 50714,
	BlackLevelDeltaH = 50715,
	BlackLevelDeltaV = 50716,
	WhiteLevel = 50717,
	DefaultScale = 50718,
	DefaultCropOrigin = 50719,
	DefaultCropSize = 50720,
	ColorMatrix1 = 50721,
	ColorMatrix2 = 50722,
	CameraCalibration1 = 50723,
	CameraCalibration2 = 50724,
	ReductionMatrix1 = 50725,
	ReductionMatrix2 = 50726,
	AnalogBalance = 50727,
	AsShotNeutral = 50728,
	AsShotWhiteXY = 50729,
	BaselineExposure = 50730,
	BaselineNoise = 50731,
	BaselineSharpness = 50732,
	BayerGreenSplit = 50733,
	LinearResponseLimit = 50734,
	CameraSerialNumber = 50735,
	LensInfo = 50736,
	ChromaBlurRadius = 50737,
	AntiAliasStrength = 50738,
	ShadowScale = 50739,
	DNGPrivateData = 50740,
	MakerNoteSafety = 50741,
	CalibrationIlluminant1 = 50778,
	CalibrationIlluminant2 = 50779,
	BestQualityScale = 50780,
	RawDataUniqueID = 50781,
	OriginalRawFileName = 50827,
	OriginalRawFileData = 50828,
	ActiveArea = 50829,
	MaskedAreas = 50830,
	AsShotICCProfile = 50831,
	AsShotPreProfileMatrix = 50832,
	CurrentICCProfile = 50833,
	CurrentPreProfileMatrix = 50834,
	ColorimetricReference = 50879,
	CameraCalibrationSignature = 50931,
	ProfileCalibrationSignature = 50932,
	ExtraCameraProfiles = 50933,
	AsShotProfileName = 50934,
	NoiseReductionApplied = 50935,
	ProfileName = 50936,
	ProfileHueSatMapDims = 50937,
	ProfileHueSatMapData1 = 50938,
	ProfileHueSatMapData2 = 50939,
	ProfileToneCurve = 50940,
	ProfileEmbedPolicy = 50941,
	ProfileCopyright = 50942,
	ForwardMatrix1 = 50964,
	ForwardMatrix2 = 50965,
	PreviewApplicationName = 50966,
	PreviewApplicationVersion = 50967,
	PreviewSettingsName = 50968,
	PreviewSettingsDigest = 50969,
	PreviewColorSpace = 50970,
	PreviewDateTime = 50971,
	RawImageDigest = 50972,
	OriginalRawFileDigest = 50973,
	SubTileBlockSize = 50974,
	RowInterleaveFactor = 50975,
	ProfileLookTableDims = 50981,
	ProfileLookTableData = 50982,
	OpcodeList1 = 51008,
	OpcodeList2 = 51009,
	OpcodeList3 = 51022,
	NoiseProfile = 51041,
	OriginalDefaultFinalSize = 51089,
	OriginalBestQualityFinalSize = 51090,
	OriginalDefaultCropSize = 51091,
	ProfileHueSatMapEncoding = 51107,
	ProfileLookTableEncoding = 51108,
	BaselineExposureOffset = 51109,
	DefaultBlackRender = 51110,
	NewRawImageDigest = 51111,
	RawToPreviewGain = 51112,
	CacheBlob = 51113,
	CacheVersion = 51114,
	DefaultUserCrop = 51125,
	DepthFormat = 51177,
	DepthNear = 51178,
	DepthFar = 51179,
	DepthUnits = 51180,
	DepthMeasureType = 51181,
	EnhanceParams = 51182,
	KodakKDCPrivateIFD = 65024,
}
